<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="6" align="center">
        <router-link to="/"><v-icon>mdi-home</v-icon></router-link>
        <h1 class="text-center">Zadejte nové heslo</h1>
        <v-alert v-if="resetSuccess" color="success">Heslo bylo změněno.</v-alert>
        <v-alert v-if="resetError" color="error">Chyba.</v-alert>
        <v-form v-model="formValid" ref="form">
            <v-text-field
              label="Zadejte heslo"
              v-model="form.password"
              :rules="[rules.required, rules.minLength(6)]"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
            ></v-text-field>
            <v-text-field
              v-model="form.passwordConfirmation"
              label="Heslo znovu"
              :rules="[rules.required, formRules.passwordConfirmation]"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
            ></v-text-field>
            <v-btn :disabled="!formValid || wait" @click="save">Uložit</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from '@/mixins/rules'

export default {
  name: 'ResetPassword',
  mixins: [rules],
  data () {
    return {
      formValid: true,
      wait: false,
      resetSuccess: false,
      resetError: false,
      show1: false,
      show2: false,
      form: {
        email: this.$route.query.email,
        token: this.$route.query.token,
        password: '',
        passwordConfirmation: ''
      },
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      }
    }
  },
  methods: {
    save () {
      this.wait = true
      this.resetError = false
      this.resetSuccess = false
      this.$http.post('reset-password', this.keysToSnakeCase(this.form))
        .then(() => {
          this.wait = false
          this.resetSuccess = true
          this.$refs.form.reset()
          setTimeout(() => {
            this.$router.replace('/')
          }, 1500)
        })
        .catch(() => {
          this.wait = false
          this.resetError = true
        })
    }
  }
}
</script>

<style scoped>
.col{
  background-image: linear-gradient(180deg, #e3e3e3, #e0dede);
  border-radius: 25px;
  margin-top: 5vh;
  padding: 5rem;
  min-width: 400px;
  max-width: 800px;
}
.container{
  background-image: linear-gradient(180deg, #028302, #94f80b) !important;
  max-width: 100%;
  height: 100vh;
}
</style>
